// DomUserPicture
import ClassNames from 'classnames';
import React from 'react';

import DomImage from './DomImage.jsx';

export default class DomUserPicture extends React.Component {
  render() {
    let itemClass = {
      'upicture': true,
      'insider': this.props.isInsider,
      'brandedColor_bg': true
    };

    if (typeof this.props.size !== undefined) {
      itemClass[this.props.size] = true;
    }

    itemClass = ClassNames(itemClass);

    const picture = (this.props.user && this.props.user.picture ? this.props.user.picture : require('../img/userDefault.png'));

    return (
      <div className={itemClass}>
        <DomImage src={picture} className='brandedColor_bg' />
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/DomUserPicture.jsx